import { Content } from "@/ui";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";
import { leaders_helper } from "@/helpers/leaders_helper";
import { brands_helper } from "@/helpers/brands_helper";
import { content_tiles_helper } from "@/helpers/content_tiles_helper";
import { values_helper } from "@/helpers/values_helper";
import { Cookies } from "@/components";

export default function AboutUs({ content }) {
  return (
    <>
      <Content items={content ?? {}} />
      
    </>
  );
}

export async function getStaticProps() {
  const page = simple_pages_helper.find("about-us");

  if (!page) {
    return {
      notFound: true,
    };
  }
  
  return {
    props: {
      meta: {
        title: createTitle("About us"),
      },
      content: [
        { 
          component: "BreadcrumbNavigation", 
          props: { 
            items: [{label: "About Us", href: "/about-us"}],
            className: "mt-4",
          },
        },
        {
          component: "Hero2",
          id: "Hero2",
          props: {
            label: page.title,  
            content: page.subtitle,
            body: page.description,
            className: "hero-section",
          },
        },
        {
          component: "StatsHighlight",
          id: "StatsHighlight",
          props: {
            statistics: page.statistics, 
          },
        },
        {
          component: "OurBrands",
          props: {
            title: {
              path: "page.home.component.brands.title",
              placeholder: "Title",
            },
            description: {
              path: "page.home.component.brands.description",
              placeholder: "Personalised relationships, Sector specialisms, Global presence",
            },
            brands: brands_helper.fetch(),
          },
        },
        {
          component: "Services",
          id: "Services",
          props: {
            label: page.services_title, 
          },
        },
        {
          component: "Testimonials",
          props: {}
        },
        // {
        //   component: "MeetTheLeaders",
        //   props: {
        //     title: page.leaders_title,
        //     leaders: leaders_helper.fetch(),
        //   },
        // },
        {
          component: "OurValues",
          props: {
            title: page.values_title,
            brands: values_helper.fetch(),
          },
        },
        {
          component: "HomeTiles",
          props: {
            items: content_tiles_helper.fetch({category: page.carousel_category}),
            style: page.carousel_style || "",
          }
        },
      ],
    },
  };
}
